/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react'

import Card from 'react-bootstrap/Card'
import moment from 'moment'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import SearchIcon from '@material-ui/icons/Search';
import * as Icons from '../images'


import Swal from 'sweetalert2'
// import BeaconContent from './BeaconContent'
import axios from 'axios';
import { history } from '../router/route';
import icon_building from '../images/icon-building.svg';
import icon_calendar from '../images/icon-calendar.svg';
import icon_export from '../images/export.png';
import { Button, Dropdown, Form, Nav, Navbar, InputGroup, Container, Col, Row } from 'react-bootstrap';

function Icon({ icon, ...props }) {
    const Icon = Icons[icon]
    return <Icon {...props} />
}


const FullReport = (props) => {


    useEffect(() => {
        // requestBeacons()
    }, [props])

    async function requestBeacons() {
        const params = {
            "work": "BEACON.LIST",
            "item_per_request": 100,
            "current_item_amount": 0
        }
        const res = await axios.post(`${process.env.REACT_APP_BEV_API}/v3/apis/beacon`, params, {
            auth: {
                username: process.env.REACT_APP_USERNAME,
                password: process.env.REACT_APP_PASSWORD
            }
        });

    }




    function onClickToDetail() {
        history.push('/zone')
    }

    return (
        <>
            <Container fluid>
                <Navbar fixed="top" className='py-3 border' bg="white" expand="lg" variant="light">
                    <Nav.Link href="#home"><ArrowBackIosIcon></ArrowBackIosIcon> Back To Map</Nav.Link>
                    <Navbar.Toggle />
                    <Navbar.Collapse className="justify-content-end">
                        <Navbar.Text className="text-dark mx-1 clearfix">
                            <span className='float-left p-1'>แสดงข้อมูลวันล่าสุด 5 ม.ค. - 5 ม.ค. 2022</span>
                            <Dropdown className='mx-2 float-right'>
                                <Dropdown.Toggle variant="outline-light" className="text-dark border px-1 d-flex align-items-center" id="dropdown-basic">
                                    <img
                                        width={20}
                                        height={20}
                                        src={icon_calendar}
                                        alt="icons export"
                                    />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                                    <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                    <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Navbar.Text>
                        <Form>
                            <Button variant="outline-light" className="text-dark border d-flex align-items-center ml-1">
                                <img
                                    width={20}
                                    height={20}
                                    className="mr-2"
                                    src={icon_export}
                                    alt="icons export"
                                />
                                <span>Export to excel</span>
                            </Button>
                        </Form>

                    </Navbar.Collapse>
                </Navbar>
                
                {/* <nav class="navbar navbar-light bg-light">
                    <a class="navbar-brand">Navbar</a>
                    <form class="form-inline">
                        <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search" />
                        <button class="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button>
                    </form>
                </nav> */}
                <div className="d-flex justify-content-between d-flex align-items-center py-3 mt-3">
                    <div className="d-flex align-items-center">
                        <Icon
                            className="mr-2 align-self-center"
                            width={32}
                            height={32}
                            aria-hidden="true"
                            icon='BuildingIcon'
                            style={{ "color": "#027840" }}
                        />
                        <div className="d-flex flex-column">
                            <h5 className='mb-0'>ตึกแสงโสม</h5>
                            <p className='mb-0'>8 Beacones</p>
                        </div>
                    </div>
                    <div className="d-flex flex-column">
                        <label className='mb-0 text-muted text-uppercase'>All Records</label>
                        <h5 className='mb-0 font-weight-normal'>1,220</h5>
                    </div>
                    <p className='text-break mb-0'>83 Liap Khlong Mon Rd, Thap Yao, Lat Krabang, Bangkok 10520</p>
                    <div className="d-flex flex-column">
                        <label className='mb-0 text-muted text-bolder'>ละติจูด</label>
                        <h6 className='mb-0 font-weight-normal'>13.844701</h6>
                    </div>
                    <div className="d-flex flex-column">
                        <label className='mb-0 text-muted text-bolder'>ลองติจูด</label>
                        <h6 className='mb-0 font-weight-normal'>13.844701</h6>
                    </div>
                    <Form>
                        {/* <Form.Group controlId="formsearch">
                        <Form.Control type="text" placeholder="" style={{ width: 320, paddingLeft: '2.5rem' }} />                   
                    </Form.Group>  */}
                        <Form.Group className='mb-0'>
                            <InputGroup.Prepend className='position-absolute'>
                                <InputGroup.Text id="basic-addon1" className="bg-white border-0 bg-transparent mt-1">
                                    <SearchIcon></SearchIcon>
                                </InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control type="text" placeholder="ค้นหารหัสพนังงาน" style={{ paddingLeft: '2.5rem' }} />
                        </Form.Group>

                    </Form>
                </div>
            </Container>

            <Container fluid>
                {/* <Row> */}
                {/* <Card className="border-0"> */}
                {/* <Card.Header className="px-0"> */}
                <div className="d-flex flex-row py-3">
                    <div className="d-flex align-items-center">
                        <img
                            width={24}
                            height={24}
                            className="mr-2 align-self-center"
                            src={icon_building}
                            alt="Generic placeholder"
                        />
                        <div className="d-flex flex-column">
                            <h6 className='mb-0'>ZONE A</h6>
                            <p className='mb-0'>8 Beacones</p>
                        </div>
                    </div>
                    <div className="d-flex align-items-center ml-3">
                        <div className="d-flex flex-column">
                            <h6 className='mb-0 text-uppercase font-weight-normal text-black-50'>Records</h6>
                            <p className='mb-0'>402</p>
                        </div>
                    </div>
                </div>
                {/* </Card.Header> */}
                {/* <Card.Body className='px-0'> */}
                {/* <div className="d-flex justify-content-start"> */}
                <Row>
                    <Col className="d-flex align-items-center">
                        <Icon
                            className="mr-2 align-self-center"
                            width={40}
                            height={40}
                            aria-hidden="true"
                            icon='BeaconIcon'
                            style={{ "color": "#027840" }}
                        />
                        <div className="d-flex flex-column">
                            <h6 className='mb-0'>251 - ThaiBev</h6>
                            <p className='mb-0'>พบข้อมูล 4 รายการ</p>
                        </div>
                    </Col>
                    <Col className="d-flex align-items-center">
                        <Icon
                            className="mr-2 align-self-center"
                            width={40}
                            height={40}
                            aria-hidden="true"
                            icon='BeaconIcon'
                            style={{ "color": "#027840" }}
                        />
                        <div className="d-flex flex-column">
                            <h6 className='mb-0'>251 - ThaiBev</h6>
                            <p className='mb-0'>พบข้อมูล 4 รายการ</p>
                        </div>
                    </Col>
                    <Col className="d-flex align-items-center">
                        <Icon
                            className="mr-2 align-self-center"
                            width={40}
                            height={40}
                            aria-hidden="true"
                            icon='BeaconIcon'
                            style={{ "color": "#027840" }}
                        />
                        <div className="d-flex flex-column">
                            <h6 className='mb-0'>251 - ThaiBev</h6>
                            <p className='mb-0'>พบข้อมูล 4 รายการ</p>
                        </div>
                    </Col>
                    <Col className="d-flex align-items-center">
                        <Icon
                            className="mr-2 align-self-center"
                            width={40}
                            height={40}
                            aria-hidden="true"
                            icon='BeaconIcon'
                            style={{ "color": "#027840" }}
                        />
                        <div className="d-flex flex-column">
                            <h6 className='mb-0'>251 - ThaiBev</h6>
                            <p className='mb-0'>พบข้อมูล 4 รายการ</p>
                        </div>
                    </Col>
                </Row>
                {/* </div> */}
                {/* </Card.Body> */}
                {/* </Card> */}
                {/* </Row> */}
            </Container>

        </>
    )

}

export default FullReport